export default __webpack_public_path__ + "static/media/SureshParimi.52f94843.pdf";